import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DetailedDossierStatus, DossierStatus } from "../../types/Dossier";

export const getEmployerDossierTerminationStatus = (
  dossierId: string,
  overrideStatus?: DossierStatus,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["employerDossierTerminationStatus", dossierId],
    queryFn: (): Promise<DetailedDossierStatus> => {
      return fetchWithAuth<DetailedDossierStatus>(
        "getEmployerDossierTerminationStatus",
        dossierId,
        {
          queryParams: {
            overrideStatus: overrideStatus ?? undefined,
          },
        }
      );
    },
    enabled: isQueryEnabled(options),
  });
};
